let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6h8Ae")).then(() => parcelRequire('461Di'));